import {FnolManagerBackend, FnolManagerFrontend, FnolPublishedFormsBackend} from './application-configurations';
import {SupportedLanguage} from '../localization/supported-languages';

export const baseBackendConfiguration: FnolManagerBackend = {
  baseUrl: 'http://localhost:5271',
  postSubmitFormPath: 'api/public/submissions',
  postFinalizeSubmitFormPath: 'api/public/submissions/{submissionId}/finalize',
  getFormPath: 'api/public/form/{formId}/{formVersion}',
}

export const baseFrontendConfiguration: FnolManagerFrontend = {
  baseUrl: 'http://localhost:4200',
  localisationConfiguration: {
    defaultLanguage: {
      languageId: "thai",
      nativeLanguageName: "ไทย",
      englishLanguageName: "Thai"
    },
    supportedLanguages: [
      {
        languageId: 'english',
        nativeLanguageName: 'English',
        englishLanguageName: 'English'
      },
      {
        languageId: 'german',
        nativeLanguageName: 'Deutsch',
        englishLanguageName: 'German'
      },
      {
        languageId: "thai",
        nativeLanguageName: "ไทย",
        englishLanguageName: "Thai"
      }
    ].sort((a: SupportedLanguage, b: SupportedLanguage) => a.englishLanguageName.localeCompare(b.englishLanguageName)),
    translationsBasePath: '/data/localizations/languages'
  }
}

export const fnolPublishedFormsBackend : FnolPublishedFormsBackend = {
  baseUrl: 'https://forms-fnol-app.devtest.pxcatclaim.com',
  getPublishedFormDefinitionPath: 'forms/{formId}/{formVersion}/definition.json'
}
